<form class="edit-modal kw-dialog" (ngSubmit)="submit()" name="lotInputForm" id="lotInputForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.lot.id ? 'Update' : 'New'}} {{"Lot" | tenantWords}}</h2>
      <div class="modal-subtitle">{{this.lot.id ? this.lot.lotNumber : 'Fields marked * are required'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <ng-container *ngIf="!this.isLoading">
      <section class="form-section">
        <div class="section-head">
          <fa-icon [icon]="faLayerGroup" class="section-icon"></fa-icon>
          <h3>{{"Lot" | tenantWords}}</h3>
        </div>
        <div class="section-grid cols-3">
          <mat-form-field appearance="outline">
            <mat-label>Lot Number</mat-label>
            <input [(ngModel)]="this.lot.lotNumber" matInput type="text" required id="lotNameInput" name="lotNameInput">
            <button *ngIf="this.lot.lotNumber" matSuffix mat-icon-button aria-label="Clear" type="button"
              (click)="this.lot.lotNumber = null">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Variety</mat-label>
            <mat-select name="variety" [(ngModel)]="this.lot.varietyId">
              <mat-option *ngFor="let f of this.varieties" [value]="f.id">
                {{f.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Crop Year</mat-label>
            <mat-select name="selectedCropYear" [(ngModel)]="this.lot.cropYearId">
              <mat-option *ngFor="let f of this.years" [value]="f.id">
                {{f.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Parent Lot</mat-label>
            <mat-select name="parentLot" [(ngModel)]="this.lot.parentLotId">
              <mat-option *ngFor="let f of this.lots" [value]="f.id">
                {{f.lotNumber}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="!isFieldHidden('Load')">
            <mat-label>Load</mat-label>
            <mat-select name="selectedLoad" [(ngModel)]="this.lot.loadId">
              <mat-option *ngFor="let f of this.loads" [value]="f.id">
                {{f.loadNumber}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="!isFieldHidden('Block')">
            <mat-label>Block</mat-label>
            <mat-select name="selectedBlock" [(ngModel)]="this.lot.blockId">
              <mat-option *ngFor="let f of this.blocks" [value]="f.id">
                {{f.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <div class="section-head">
          <fa-icon [icon]="faSliders" class="section-icon"></fa-icon>
          <h3>Details</h3>
        </div>
        <div class="section-grid cols-3">
          <mat-form-field appearance="outline">
            <mat-label>Expiration Date</mat-label>
            <input matInput [(ngModel)]="this.lot.experationDate" name="experationDate" id="experationDate"
              [matDatepicker]="datePicker">
            <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Initial Qty.</mat-label>
            <input [(ngModel)]="this.lot.initialQuantity" matInput type="number" id="initialQuantityInput"
              name="initialQuantityInput">
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="!isFieldHidden('Generation')">
            <mat-label>Generation</mat-label>
            <input [(ngModel)]="this.lot.generation" matInput type="number" id="generationInput" name="generationInput">
          </mat-form-field>

          <mat-form-field appearance="outline"
            *ngIf="this.authService.hasRole('greenhouse:admin') || this.authService.hasRole('lab:scheduler')">
            <mat-label>Accession</mat-label>
            <mat-select name="accession" [(ngModel)]="this.lot.defaultItemId">
              <mat-option *ngFor="let f of this.accessionItems" [value]="f.id">
                {{f.name}} ({{f.varietyName}})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngFor="let field of this.lot.attributes">
            <ng-container *ngIf="!isFieldHidden(field.customAttributeName)">
              <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.customAttributeDatatype == 'string'"
                appearance="outline">
                <mat-label>{{field.customAttributeName}}</mat-label>
                <input [(ngModel)]="field.value" [required]="true" matInput type="text" id="custField{{field.id}}"
                  name="custField{{field.id}}">
                <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
                  (click)="field.value = ''">
                  <fa-icon [icon]="faXmark"></fa-icon>
                </button>
              </mat-form-field>

              <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.customAttributeDatatype == 'number'"
                appearance="outline">
                <mat-label>{{field.customAttributeName}}</mat-label>
                <input [(ngModel)]="field.value" [required]="true" matInput type="number" id="custField{{field.id}}"
                  name="custField{{field.id}}">
                <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
                  (click)="ClearValue(field)">
                  <fa-icon [icon]="faXmark"></fa-icon>
                </button>
              </mat-form-field>

              <mat-form-field *ngIf="getOptionsLength(field) > 0" appearance="outline">
                <mat-label>{{getFieldName(field)}}</mat-label>
                <mat-select [required]="true" name="fieldOptions{{field.id}}" [(ngModel)]="field.value"
                  id="custField{{field.id}}">
                  <mat-option *ngFor="let w of getFieldOptions(field)" [value]="w.value">
                    {{w.display}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </div>
      </section>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.lot.id" mat-stroked-button class="danger-btn" type="button" (click)="deleteLot()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
